<template>
  <div class="chart-evolution-loyer">
    <p class="label main_color_text" :class="{'--medium': dense}" v-if="chart_evolution_loyers.title">
      {{
        typeof chart_evolution_loyers.title == "string"
          ? chart_evolution_loyers.title
          : chart_evolution_loyers.title.value
          ? chart_evolution_loyers.title.value
          : ""
      }}
    </p>
    <el-line-chart
      :key="evolution_loyer_chart_key"
      name="evolution_loyers"
      :values="data_chart"
      :height="162"
    />
  </div>
</template>

<script>
import elLineChart from "../el-line-chart.vue";
export default {
	components: { elLineChart },
	props: ["chart_evolution_loyers", "evolution_loyer_chart_key", "dense"],
	computed: {
		data_chart () {
			const rData = {...this.chart_evolution_loyers};
			rData.datasets.forEach(ds =>
				ds["data"].forEach(function (element, index, arr) {
					if(element === null || element.toString()==="0" || element.toString()==="-"){
						arr[index]=null;
					}
				})
			);
			return rData;
		}
	}
};
</script>

<style lang="scss">
.chart-evolution-loyer {
  height: 100%;

  .el-line-chart {
    position: relative;
    height: 100%;
    .chart {
      canvas {
        position: absolute;
        margin-top: 0;
        padding-top: 0;
        top: 0;
      }
    }
  }
}
</style>